import React, { Fragment, useEffect, useState, useRef } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import Selector from "pages/_components/fields/formik/Selector";
import TextField from "pages/_components/fields/TextField";
import AmountField from "pages/_components/fields/formik/AmountField";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import useSchema from "hooks/useSchema";
import { routerActions } from "connected-react-router";
import { actions as afipActions } from "reducers/afipPayments";
import { isEmpty } from "lodash";
import GridTable from "pages/_components/GridTable/GridTable";

const FORM_ID = "afipPayments.newAfip";

const AfipDynamicForm = () => {
    const { fetching, afipForms, afipFields, afipByCodes, afipPaymentData } = useSelector(
        (state) => state.afipPayments,
    );
    const { stringRequired } = useSchema();
    const [keyValue, setKeyValue] = useState("");
    const dispatch = useDispatch();
    const initialValues = {};
    const snakeToCamel = (str) =>
        str.toLowerCase().replace(/([-_][a-z])/g, (group) =>
            group
                .toUpperCase()
                .replace("-", "")
                .replace("_", ""),
        );
    function camelToSnake(str) {
        return str.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);
    }
    useEffect(() => {
        if (afipForms.length === 0) {
            dispatch(afipActions.afipFormListReducer());
        }
    }, []);

    afipFields.forEach((element) => {
        const formData = afipPaymentData?.formData;

        if (formData) {
            let inputData;
            formData.map((data) => {
                if (data?.label === element.name.toUpperCase().replace("_", " ")) {
                    inputData = data.inputData;
                }
            });

            initialValues[element.name] = inputData;
        }
    });
    const afipAccountsValidation = Yup.lazy(() => {
        const validate = {};
        afipFields.forEach((element) => {
            Object.entries(element).forEach((entry) => {
                const [key, value] = entry;
                if (key === "name") {
                    validate[value] = stringRequired;
                }
            });
        });
        return Yup.object().shape(validate);
    });

    const handleChangeForm = (code) => {
        dispatch(afipActions.afipFormFieldsReducer(code));
    };

    const formRef = useRef(null);

    useEffect(() => {
        const formCode = afipPaymentData?.form;
        if (!formRef.current) {
            return;
        }
        if (isEmpty(initialValues)) {
            return;
        }
        if (formCode === undefined) {
            return;
        }
        initialValues.form = formCode;
        formRef.current.resetForm(initialValues);
    }, [afipFields]);

    const handleChangeDynamicText = (e, values) => {
        const regex = /^(0[1-9]|1[0-2])[0-9]{4}$/;
        const inputValue = e.target.value.trim();
        const value = {};
        value[keyValue] = e.target.value;
        if (inputValue.length === 6 && regex.test(inputValue)) {
            if (camelToSnake(keyValue) === e.target.name) {
                dispatch(
                    afipActions.afipFormFieldCodeReducer(snakeToCamel(e.target.name), e.target.value, values.form),
                );
            }
        }
    };

    const formatComboOne = (e) => e?.map((item) => ({ value: item.code, label: `${item.code} - ${item.description}` }));

    const textFieldTypes = (afipValues, typeField, values, index, pattern) => (
        <Field
            component={typeField}
            idForm={FORM_ID}
            name={afipValues?.name}
            label={afipValues?.label}
            labelText={afipValues?.label}
            placeholder={afipValues?.mask}
            pattern={pattern}
            maxLength={afipValues?.length > 0 ? afipValues?.length : 100}
            labelFromService
            key={`${FORM_ID}${index}`}
            handleOnChange={(e) => handleChangeDynamicText(e, values)}
        />
    );

    const objectToArray = (data) => {
        const arr = Object.entries(data);
        const arrOfObj = arr.map((item) => ({ value: item[0], label: item[1] }));
        return arrOfObj;
    };

    const formatetArray = (data) => {
        const arr = Object.entries(data);
        const arrOfObj = arr.map((item) => ({ value: item[1], label: item[1] }));
        return arrOfObj;
    };

    const comboBoxTypes = (md, name, label, options, index) => (
        <Field
            component={Selector}
            idForm={FORM_ID}
            name={name}
            label={label}
            options={options}
            placeholder={`${i18n.get("global.select")}`}
            placeholderFromService
            isLoading={fetching}
            key={`${FORM_ID}${index}`}
        />
    );
    const handleSubmit = (values) => {
        const codForm = values.form;
        const obj = values;
        delete obj.form;
        const formSelected = afipForms.find((formValue) => formValue?.code === codForm);
        const formName = `${formSelected?.code} - ${formSelected?.description}`;
        const formData = [];
        afipFields.forEach((element) => {
            Object.entries(values).forEach((entry) => {
                const [key, value] = entry;
                if (element.name === key) {
                    formData.push({ label: element.label, inputData: value });
                }
            });
        });
        const valuesNoForm = { ...values };
        delete valuesNoForm.form;
        dispatch(afipActions.setAfipPaymentData({ form: codForm, formName, formData, valuesNoForm }));
        dispatch(afipActions.afipTaxFormsReducer(codForm, obj));
        dispatch(routerActions.push("/afip/newPayment/account"));
    };

    const handleDisabled = (values) => {
        let data = true;
        if (Object.keys(values).length > 1) {
            Object.entries(values).forEach((element) => {
                const [key, value] = element;
                if (value === "") {
                    data = false;
                }
                return key;
            });
        } else {
            data = false;
        }
        return data;
    };

    const getColumnStart = (index) => 2 + (index % 2) * 5;

    return (
        <Fragment>
            <Notification scopeToShow="newAfip" />
            <ResponsiveHeader id="afipPayments.newAfip.title" />
            <MainContainer>
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={afipAccountsValidation}
                    ref={formRef}>
                    {({ values }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data columnStart={2} columnWidth={10}>
                                        <Field
                                            component={Selector}
                                            idForm={FORM_ID}
                                            name="form"
                                            key="formKey"
                                            label={i18n.get("afipPayments.forms.label")}
                                            options={formatComboOne(afipForms)}
                                            placeholder={`${i18n.get("global.select")}`}
                                            placeholderFromService
                                            onChange={(e) => handleChangeForm(e)}
                                            isLoading={fetching}
                                        />
                                    </GridTable.Data>
                                    {values.form &&
                                        afipFields.map((afipValues, index) => {
                                            let returnForm;
                                            let typeField;
                                            let pattern;
                                            if (afipValues?.type === "ALF") {
                                                typeField = TextField;
                                            }
                                            if (afipValues?.type === "FEC") {
                                                typeField = TextField;
                                                pattern = "^[0-9]*$";
                                            }
                                            if (afipValues?.type === "IMP") {
                                                typeField = AmountField;
                                            }
                                            if (afipValues?.type === "CBA") {
                                                typeField = TextField;
                                            }
                                            if (afipValues.component === "TEXT_FIELD") {
                                                returnForm = (
                                                    <GridTable.Data columnStart={getColumnStart(index)} columnWidth={5}>
                                                        {textFieldTypes(afipValues, typeField, values, index, pattern)}
                                                    </GridTable.Data>
                                                );
                                            }
                                            if (afipValues.component === "HIDDEN_TEXT_FIELD") {
                                                returnForm = (
                                                    <GridTable.Data columnStart={getColumnStart(index)} columnWidth={5}>
                                                        {textFieldTypes(afipValues, "hidden", values, index, pattern)}
                                                    </GridTable.Data>
                                                );
                                            }
                                            if (afipValues.component === "COMBO_BOX_ESTATICO") {
                                                const comboStatic = formatetArray(afipValues?.staticComboxValues);
                                                returnForm = (
                                                    <GridTable.Data columnStart={getColumnStart(index)} columnWidth={5}>
                                                        {comboBoxTypes(
                                                            6,
                                                            afipValues?.name,
                                                            afipValues?.label,
                                                            comboStatic,
                                                            index,
                                                        )}
                                                    </GridTable.Data>
                                                );
                                            }
                                            if (afipValues.component === "COMBO_BOX_DINAMICO") {
                                                Object.entries(afipValues.dynamicComboxValues).forEach((entry) => {
                                                    const [key] = entry;
                                                    setKeyValue(key);
                                                });

                                                const comboDynamic = objectToArray(afipByCodes);
                                                returnForm = (
                                                    <GridTable.Data columnStart={getColumnStart(index)} columnWidth={5}>
                                                        {comboBoxTypes(
                                                            6,
                                                            afipValues?.name,
                                                            afipValues?.label,
                                                            comboDynamic,
                                                            index,
                                                        )}
                                                    </GridTable.Data>
                                                );
                                            }
                                            return returnForm;
                                        })}
                                </GridTable.Container>
                            </GridTable>
                            {values.form && (
                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={!handleDisabled(values)}
                                            onClick={() => handleSubmit(values)}
                                        />
                                    </Col>
                                </Row>
                            )}
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Fragment>
    );
};

export default AfipDynamicForm;
